export class Institute {
	id = 0;
	shortName = '';
	name = '';
	active = true;
}
